import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { originalEmailActions } from '../actions/originalEmail';
import * as originalEmailApi from '../api/originalEmail';
const { originalEmailGet, originalEmailGetSucceeded, originalEmailGetFailed, originalEmailHtmlGetByType, originalEmailHtmlGetByTypeSucceeded, originalEmailHtmlGetByTypeFailed, originalEmailGetHtmlMessage, originalEmailGetHtmlMessageSucceeded, originalEmailGetHtmlMessageFailed, originalEmailGetPrinterFriendly, originalEmailGetPrinterFriendlySucceeded, originalEmailGetPrinterFriendlyFailed, } = originalEmailActions;
// Saga
export const originalEmail = [
    takeLatest(originalEmailGet.toString(), genWithPromiseWithRequestUrl(originalEmailApi.originalEmailGet, originalEmailGetSucceeded, originalEmailGetFailed)),
    takeEvery(originalEmailGetHtmlMessage.toString(), genWithPromiseHtmlEmailMessage(originalEmailApi.originalEmailGet, originalEmailGetHtmlMessageSucceeded, originalEmailGetHtmlMessageFailed)),
    takeLatest(originalEmailGetPrinterFriendly.toString(), genWithPromiseWithRequestUrl(originalEmailApi.originalEmailGet, originalEmailGetPrinterFriendlySucceeded, originalEmailGetPrinterFriendlyFailed)),
    takeEvery(originalEmailHtmlGetByType.toString(), genWithPromise(originalEmailApi.originalEmailGetByType, originalEmailHtmlGetByTypeSucceeded, originalEmailHtmlGetByTypeFailed)),
];
function genWithPromise(apiAction, resultSucceededAction, resultFailedAction) {
    return function* (action) {
        let result;
        try {
            result = yield call(apiAction, action.payload);
            yield call(action.meta.resolve, result);
            yield put(resultSucceededAction(result));
        }
        catch (exception) {
            console.warn(exception);
            // Something went wrong. We reject the promise.
            yield call(action.meta.reject, exception);
            result = exception;
            yield put(resultFailedAction(result));
        }
    };
}
function genWithPromiseWithRequestUrl(apiAction, resultSucceededAction, resultFailedAction) {
    return function* (action) {
        let result;
        try {
            result = yield call(apiAction, action.payload);
            result.requestURL = action.payload.url;
            yield call(action.meta.resolve, result);
            yield put(resultSucceededAction(result));
        }
        catch (exception) {
            console.warn(exception);
            // Something went wrong. We reject the promise.
            yield call(action.meta.reject, exception);
            result = exception;
            yield put(resultFailedAction(result));
        }
    };
}
function genWithPromiseHtmlEmailMessage(apiAction, resultSucceededAction, resultFailedAction) {
    return function* (action) {
        let result;
        try {
            result = yield call(apiAction, action.payload);
            const urlArray = action.payload.url.split('/');
            result.messageId = urlArray.pop();
            result.requestURL = action.payload.url;
            result.csid = action.payload.csid;
            yield call(action.meta.resolve, result);
            yield put(resultSucceededAction(result));
        }
        catch (exception) {
            console.warn(exception);
            // Something went wrong. We reject the promise.
            yield call(action.meta.reject, exception);
            result = exception;
            yield put(resultFailedAction(result));
        }
    };
}
